import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { SharedProgrammingService } from '../../common/services/shared-programming.service';
import { Event } from '../../common/interfaces/event.interface';
import { EventsService } from '../../common/services/events.service';
import { EVENTS_FILTER } from '../events/eventsUI.service';

@Component({
  selector: 'prg-list-by-type',
  templateUrl: './list-by-type.component.html'
})
export class ListByTypeComponent implements OnInit {

  ready: Observable<boolean>;
  searchText: Observable<string>;
  deviceEvents: Observable<Event[]>;
  expanded: Observable<boolean>;

  @Input() creatorFilter: EVENTS_FILTER;

  constructor(
    private store: Store<any>,
    private route: ActivatedRoute,
    protected router: Router,
    private events: EventsService,
    private shared: SharedProgrammingService
  ) {
    this.ready = this.shared.isReady;
    this.searchText = this.shared.searchText;
    this.deviceEvents = this.events.programmedEvents;
    this.expanded = this.shared.listExpanded;
  }

  ngOnInit() {
    this.shared.clearError();
    this.shared.setGrouping('device');
  }

  private tileClicked(item: any) {
    console.log('tile clicked: ', item);
    if (item) {
      // this.shared.setSelectedEvent(item).then(res => {
      this.router.navigate(['../../device', item.deviceId, 'event', item.eventId, 'edit'], { relativeTo: this.route });
      // });
    }
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/list-by-type/list-by-type.component.ts